import { gql } from '@apollo/client';

interface AcreditacionProfileFields{
     uuid:number
     name:string
     email:string
     rol:string
}

export enum AcreditacionProfileRol{
    PROFILE='PROFILE'
}


export default class AcreditacionProfile{
    public static getToken= ():string|null =>{
        return this.getCookie('token')
    }

    public static isLoginIn= (props:{token:string}):boolean => {
        if(props?.token)
            this.setToken(props.token)

        const token = this.getCookie('token');
        return (token)?true:false;
    }

    public static setToken= (token:string)=>{
        this.setCookie('token',token,7)
    };

    public static setProfile= (user:AcreditacionProfileFields)=>{
        this.setCookie('profile',JSON.stringify(user),7);
    }

    public static getProfile= ():AcreditacionProfileFields =>{
        let UserJson=this.getCookie('profile') || '{}';
        return JSON.parse(UserJson);
    };

    public static logOut= ()=>{
        //old credentials
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('profile');

        this.delCookie('token');
        this.delCookie('profile');
    };  

    public static getLabelFromValue(list:object[],value:string){
        let label=value;
        list.forEach( object => {
            if(object.value===value)
                label=object.label;
        });
        return label;
    };
        
    public static delCookie(name:string) {
        document.cookie = `${name}=${''};expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
    }
    
    public static setCookie(name:string, value:string, hours?:number) {
        let expires = '';
        if (hours) {
            const date = new Date();
            date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
            expires = `; expires=${date.toUTCString()}`;
        }
        document.cookie = `${name}=${value || ''}${expires}; path=/`;
    }
    
    public static getCookie(name:string) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

}

export const LOGIN_IN = gql`
    mutation loginInProfile($email:String!,$password:String!){
        loginInProfile(email:$email,password:$password){
        profile{
            id,
            uuid,
            name,
            email,
            is_valid_email,
        },
        token
        }
    }  
`;


export const CREATE_ACREDITACION = gql`
    mutation createProfile($input:inputCreateProfile!){
        createProfile(input:$input){
            uuid,
            email,
            is_valid_email
        }
    }
`;

export const VALIDATE_ACREDITACION= gql`
    mutation validProfile($profile_uuid:ID!, $code:String! $input:inputUpdateProfile!){
        validProfile(profile_uuid:$profile_uuid input:$input code:$code){
        profile{
            id,
            uuid,
            email,
            is_valid_email
        },
            token
        }
    }
`;

export const GET_PROFILE= gql`
    query getAcreditacionProfile($profile_uuid:ID!){
        getAcreditacionProfile(profile_uuid:$profile_uuid){
            id,
            uuid,
            name,
            last_name,
            second_last_name,
            gender,
            email,
            tel_cell,
            birth_date, 
            avatar_url,

            curp,
        }
    }
`;


export const UPDATE_PROFILE=gql`
    mutation updateProfile($profile_uuid:ID! $input:inputUpdateProfile!){
        updateProfile(profile_uuid:$profile_uuid, input:$input){
            uuid
        }
    }
`;

export const CREATE_RECUPERAR_PASSWORD=gql`
    mutation createForgotPassword($email:String!){
        createForgotPassword(email:$email){
            uuid
        }
    }
`;


export const UPDATE_RECUPERAR_PASSWORD=gql`
     mutation updateForgotPassword($profile_uuid: ID! $password:String! $code:String!){
        updateForgotPassword(profile_uuid:$profile_uuid password:$password, code:$code)
    }   
`;

export const GET_ACREDITACION_PDF=gql`
    mutation getAcreditacionPDF($profile_uuid:ID!){
        getAcreditacionPDF(profile_uuid:$profile_uuid)
    }
`;

export const listGenero=[
    {label: 'Seleccionar género',value: ''},    
    {
        label: 'Masculino',
        value: 'masculino',
    },
    {
        label: 'Femenino',
        value: 'femenino',
    }
];

export const GET_INFO_PROFILE_BY_EMAIL=gql`
query getAcreditationProfileByEmai($profile_uuid:ID! $code:String!){
    getAcreditationProfileByEmail(profile_uuid:$profile_uuid code:$code){
      name,
      last_name,
      second_last_name,
      gender,
      tel_cell,
      birth_date,
    }
}
`;

export const LIST_ABONOS_PROFILE=gql`
    mutation listAbonos($profile_uuid:ID!){
        listAbonos(profile_uuid:$profile_uuid){
            edge{
                id,
                zona,
                seccion,
                tipo,
                vista,
                fila,
                asiento
            },
            total
        }
    }  
`;